
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M6.381 10.333c-.978 0-1.182.192-1.182 1.111v1.667c0 .92.204 1.111 1.182 1.111h2.364v6.667c0 .92.204 1.111 1.181 1.111h2.364c.978 0 1.182-.192 1.182-1.111v-6.667h2.654c.741 0 .933-.135 1.136-.806l.507-1.666c.349-1.149.134-1.417-1.137-1.417h-3.16V7.556c0-.614.529-1.112 1.182-1.112h3.363c.978 0 1.182-.191 1.182-1.11V3.11c0-.92-.204-1.111-1.182-1.111h-3.363c-3.264 0-5.91 2.487-5.91 5.556v2.777H6.382z","stroke":"#fff","stroke-width":"1.5","stroke-linejoin":"round"}})])
          )
        }
      }
    